module.exports = {"511303001":"白塔街道","511303002":"清溪街道","511303003":"小龙街道","511303004":"龙门街道","511303005":"青莲街道","511303006":"都京街道","511303007":"青松街道","511303103":"江陵镇","511303104":"擦耳镇","511303105":"老君镇","511303106":"东观镇","511303107":"长乐镇","511303108":"胜观镇","511303109":"永安镇","511303110":"阙家镇","511303111":"石圭镇","511303112":"青居镇","511303115":"会龙镇","511303116":"螺溪镇","511303201":"走马乡","511303202":"喻家乡","511303203":"马家乡","511303204":"黄溪乡","511303205":"万家乡","511303207":"御史乡","511303208":"隆兴乡","511303209":"斑竹乡","511303210":"鄢家乡","511303211":"佛门乡","511303212":"溪头乡","511303215":"凤凰乡","511303218":"南江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511303.json
// module id = 2341
// module chunks = 0